import type { GeneralTrackEvent, TrackEvent, BasicEvent } from "@common/schemas/track";
import { EventBuffer } from "./EventBuffer";
import invariant from "ts-invariant";
import { uuid } from "../utils";

export { BasicEvent };

let eventBuffer: EventBuffer | null = null;

export function initEventBuffer(apiBaseUrl: string, appId: string) {
  if (!eventBuffer) {
    eventBuffer = new EventBuffer(apiBaseUrl, appId);
  }
}

export type TrackUser = { user_id?: string; user_traits?: any; anonymous_id?: string };

type BasicTrackFn<E extends BasicEvent> = (eventData: E, user?: TrackUser) => void;

export const trackAnyEvent: BasicTrackFn<BasicEvent> = (eventData, user) => {
  invariant(eventBuffer, "Event buffer not initialized");

  try {
    const event: GeneralTrackEvent = {
      message_id: uuid() as string,
      timestamp: new Date().toISOString(),
      user_id: user?.user_id ?? null,
      user_traits: user?.user_traits ?? null,
      anonymous_id: user?.anonymous_id ?? null,
      event: eventData.event,
      type: "track" as const,
      properties: eventData.properties || {},
      context: {
        page: {
          path: location.pathname,
          search: location.search,
          title: document.title,
          url: location.href,
        },
        userAgentData: (navigator as any).userAgentData,
        userAgent: navigator.userAgent,
        locale: navigator.language,
        clientVersion: process.env.VERSION as unknown as string[],
        ...eventData.context,
      },
    };

    eventBuffer.push(event);
  } catch (e) {
    console.error("track error", e);
  }
};

// This function is similar to trackAnyEvent, but has a stricter type and only allows known events
export const track: BasicTrackFn<TrackEvent> = trackAnyEvent;

export type { TrackEvent, TrackEvents } from "@common/schemas/track";
